import { mapGetters } from 'vuex'
import Vue from 'vue'
Vue.mixin({
  computed: {
    ...mapGetters(['configs'])
  }
})
